import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Check, Lock } from 'lucide-react';
import SharedNav from '@/components/SharedNav';
import { useAuth } from '@/App';
import { isProUser } from '@/lib/entitlements';

const GREEN = '#40916C';
const FOREST = '#1F3A2E';

// Wraps a whole route/page that is Pro-only. Pro/admin see the page; Free
// users see an upgrade screen instead. Backend still enforces (402) even if
// this is bypassed.
export default function ProGate({ feature = 'This module', bullets = [], children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (isProUser(user)) return children;

  const perks = bullets.length ? bullets : [
    'Publication-grade exports (300 DPI, PDF, Excel/CSV)',
    'Advanced modules: Multi-Environment (AMMI/GGE), Path Analysis, Molecular/QTL',
    'BK Intelligence — automated AI statistical interpretation',
    'Unlimited analysis runs',
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)' }} data-testid="pro-gate">
      <SharedNav />
      <div className="max-w-[720px] mx-auto px-6 py-16 text-center">
        <div className="w-16 h-16 rounded-2xl mx-auto mb-6 flex items-center justify-center"
          style={{ background: 'rgba(64,145,108,0.12)' }}>
          <Lock size={28} style={{ color: GREEN }} />
        </div>
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full mb-4"
          style={{ background: GREEN, color: 'white', fontSize: 11.5, fontWeight: 700, letterSpacing: '0.04em' }}>
          <Crown size={13} /> PRO FEATURE
        </div>
        <h1 className="font-display" style={{ fontSize: 34, color: FOREST, letterSpacing: '-0.02em' }}>
          {feature} is a Pro feature
        </h1>
        <p className="font-body mx-auto mt-3 mb-8" style={{ fontSize: 15.5, color: 'var(--text-medium)', maxWidth: 480 }}>
          Upgrade to BKAgriD Pro to unlock it — along with everything else in the Pro toolkit.
        </p>
        <div className="bg-white rounded-2xl p-6 mb-8 text-left mx-auto" style={{ maxWidth: 460, border: '1px solid var(--border-color)' }}>
          <ul className="space-y-3">
            {perks.map((p) => (
              <li key={p} className="flex items-start gap-2.5 font-body" style={{ fontSize: 14, color: 'var(--text-dark)' }}>
                <Check size={16} style={{ color: GREEN, marginTop: 2, flexShrink: 0 }} /> {p}
              </li>
            ))}
          </ul>
        </div>
        <button onClick={() => navigate('/pricing')} data-testid="pro-gate-upgrade-button"
          className="inline-flex items-center gap-2 px-7 py-3 rounded-xl font-body btn-press transition-all"
          style={{ background: GREEN, color: 'white', fontSize: 15, fontWeight: 700, border: 'none' }}>
          <Crown size={16} /> Upgrade to Pro
        </button>
      </div>
    </div>
  );
}
